<template>
  <LoadingCard
    :loading="loading"
    class="relative"
    style="padding-bottom: 60px;"
  >
    <div class="px-4 pt-4 pb-3">
      <h3
        v-if="label !== null"
        class="font-normal"
        :class="{'cursor-pointer': this.$listeners && this.$listeners.labelClick }"
        @click="$emit('labelClick')"
      >
        <slot name="label">
          {{ label }}
        </slot>
      </h3>

      <div
        class="mt-3"
        :class="{'cursor-pointer': this.$listeners && this.$listeners.numberClick }"
        @click="$emit('numberClick')"
      >
        <h2
          class="text-5xl inline font-museo"
          :style="{color: `var(--analytics-${color})`}"
        >
          {{ formattedNumber }}
        </h2>
        <span v-if="hasPercentage" class="ml-2 text-80">({{ formattedPercentage }})</span>
        <span
          v-if="hasTrend"
          class="ml-2 mr-0 badge border-0"
          :class="color"
        >
          {{ formattedTrend }}
        </span>
      </div>

    </div>

    <div
      ref="chart"
      class="chart absolute inset-x-0"
      :class="{[color]: true, 'cursor-pointer': this.$listeners && this.$listeners.chartClick }"
      style="height: 60px; bottom:0;"
      @click="$emit('chartClick')"
    ></div>
  </LoadingCard>
</template>

<script>
  import Chartist from 'chartist';
  import LoadingCard from '@/_legacy/components/LoadingCard.vue';
  import 'chartist/dist/chartist.min.css';

  export default {
    components: { LoadingCard },
    props: {
      chartData: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: null,
      },
      number: {
        type: Number,
        default: null,
      },
      percentage: {
        type: Number,
        default: null,
      },
      trend: {
        type: Number,
        default: null,
      },
      color: {
        type: String,
        default: 'inherit',
      },
      type: {
        type: String,
        default: 'line',
      },
    },
    data: () => ({
      chartist: null,
    }),
    computed: {
      hasPercentage() {
        return this.number !== null && this.percentage !== null;
      },
      hasTrend() {
        return this.trend !== null;
      },
      formattedNumber() {
        if (this.number) {
          return this.$n(this.number, 'analyticsInteger');
        }

        if (this.percentage) {
          return this.$n(this.percentage, 'analyticsPercentage')
            .replace(' %', '%');
        }

        return 0;
      },
      formattedPercentage() {
        return this.$n(this.percentage, 'analyticsPercentage')
          .replace(' %', '%');
      },
      formattedTrend() {
        return (this.trend > 0 ? '+' : '') + this.$n(this.trend, 'analyticsTrend')
          .replace(' %', '%');
      },
      ChartConstructor() {
        switch (this.type) {
          case 'line':
            return Chartist.Line;
          case 'bar':
            return Chartist.Bar;
          default:
            return Chartist.Line;
        }
      },
    },
    watch: {
      chartData() {
        if (this.chartist) {
          this.destroyChart();
        }

        if (this.chartData) {
          this.drawChart();
        }
      },
      type() {
        if (this.chartData) {
          this.drawChart();
        }
      },
    },
    mounted() {
      if (this.chartData) {
        this.drawChart();
      }
    },
    destroyed() {
      this.destroyChart();
    },
    methods: {
      destroyChart() {
        if (this.chartist) {
          this.chartist.detach();
        }

        this.chartist = null;
      },
      drawChart() {
        this.chartist = new this.ChartConstructor(
          this.$refs.chart,
          this.chartData,
          {
            lineSmooth: Chartist.Interpolation.none(),
            fullWidth: true,
            showPoint: false,
            showLine: true,
            showArea: true,

            chartPadding: {
              top: 1,
              right: 0,
              bottom: 0,
              left: 0,
            },
            axisX: {
              showLabel: false,
              offset: 0,
              showGrid: false,
            },
            axisY: {
              showLabel: false,
              offset: 0,
              showGrid: false,
            },
          },
        );
      },
    },
  };
</script>
